"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BARE_ODW_MODEL = void 0;
exports.BARE_ODW_MODEL = {
    equipment: [],
    tags: [],
    docId: "",
    title: "",
    description: "",
    duration: 0,
    fitnessLevel: "beginner",
    media: undefined,
    thumb: undefined,
    metadata: {},
    published: false
};
//# sourceMappingURL=odwModel.js.map